module.exports = __webpack_public_path__ + "static/upper-half-c04a2fca4810c5fd2a08a446182a7cc4.svg";